const playground = {
  title: 'Chat',
  description: 'Teste e explore o Brain em tempo real',
  welcomeMessage: 'Bem-vindo ao Chat do Brain!',
  welcomeDescription: 'Aqui você pode interagir diretamente com o Brain. Faça perguntas, teste cenários e explore as capacidades do sistema.',
  inputPlaceholder: 'Digite sua mensagem para o Brain...',
  sendMessage: 'Enviar mensagem',
  noWorkspaceSelected: 'Nenhum workspace selecionado',
  selectWorkspaceFirst: 'Selecione um workspace para começar a usar o Chat',
  connecting: 'Conectando...',
  connected: 'Conectado',
  disconnected: 'Desconectado',
  reconnecting: 'Reconectando...',
  connectionError: 'Erro de conexão',
  retryConnection: 'Tentar novamente',
  chatHistory: 'Histórico de Conversas',
  clearChat: 'Limpar Chat',
  error: 'Erro',
  typing: 'Digitando...',
  userJoined: '{username} entrou no chat',
  userLeft: '{username} saiu do chat',
  playgroundAI: 'Chat IA',
  you: 'Você',

  // Painel de histórico de conversas (v2)
  sidebar: {
    newChat: 'Nova conversa',
    search: 'Buscar conversa…',
    today: 'Hoje',
    yesterday: 'Ontem',
    last7Days: '7 dias anteriores',
    older: 'Anteriores',
    empty: 'Nenhuma conversa ainda',
    noResults: 'Nenhuma conversa encontrada',
  },

  // PlaygroundView specific
  view: {
    title: 'Chat',
    subtitle: 'Converse com a IA em tempo real',
    conversation: 'Conversa: ',
    newChat: 'Nova Conversa',
    settings: 'Configurações do Chat',
    shareConversation: 'Compartilhar conversa em PDF',
    emptyStateTitle: 'Como posso te ajudar com seu projeto?',
    emptyStateSubtitle: 'Escolha uma sugestão abaixo ou digite sua própria pergunta',
    emptyChatTitle: 'Chat Vazio',
    emptyChatSubtitle: 'Envie sua primeira mensagem para começar a conversa.',
    aiThinking: 'Pensando...',
    selectingAgents: 'Selecionando agentes...',
    sendButton: 'Enviar',
    inputPlaceholder: 'Digite sua mensagem para a IA...',
    keyboardShortcuts: 'Pressione Enter para enviar, Shift + Enter para nova linha',
    noLlmTitle: 'Nenhum modelo de LLM configurado',
    noLlmDescription: 'Para conversar no Chat é necessário definir um Modelo de LLM na ferramenta, ou escolher uma ferramenta como Modelo Padrão da organização.'
  },

  // Prompt suggestions
  suggestions: {
    projectAnalysis: {
      title: 'Análise do Projeto',
      description: 'Avalie pontos fortes, fracos e oportunidades',
      prompt: 'Faça uma análise detalhada do meu projeto, incluindo pontos fortes, fracos e oportunidades de melhoria'
    },
    executivePresentation: {
      title: 'Apresentação Executiva',
      description: 'Monte uma apresentação para stakeholders',
      prompt: 'Crie um esboço de apresentação executiva sobre meu projeto para stakeholders, incluindo métricas e próximos passos'
    },
    projectStory: {
      title: 'História do Projeto',
      description: 'Crie uma narrativa envolvente sobre o projeto',
      prompt: 'Conte a história do meu projeto de forma envolvente, destacando sua jornada, evolução e impacto no mercado'
    },
    competitorAnalysis: {
      title: 'Análise de Concorrentes',
      description: 'Compare com a concorrência e identifique diferenciação',
      prompt: 'Elabore uma análise comparativa dos principais concorrentes do meu projeto, incluindo diferenciação e posicionamento'
    },
    marketingStrategy: {
      title: 'Estratégia de Marketing',
      description: 'Desenvolva campanhas e identifique canais ideais',
      prompt: 'Sugira uma estratégia de marketing digital para meu projeto, incluindo canais, mensagens e público-alvo'
    },
    projectFAQ: {
      title: 'FAQ do Projeto',
      description: 'Gere perguntas frequentes com respostas',
      prompt: 'Crie uma lista de perguntas frequentes (FAQ) sobre meu projeto com respostas detalhadas para clientes'
    }
  },

  // ChatList specific
  chatList: {
    title: 'Histórico de Conversas',
    description: 'Gerencie suas sessões de chat com o Brain',
    newChat: 'Nova Conversa',
    noChatsYet: 'Nenhuma conversa ainda',
    createFirstChat: 'Crie sua primeira conversa ou envie uma mensagem para começar',
    renameChat: 'Renomear Conversa',
    archiveChat: 'Arquivar Conversa',
    deleteChat: 'Excluir Conversa',
    deleteConfirmTitle: 'Excluir conversa?',
    deleteConfirmDescription: 'Esta ação não pode ser desfeita. A conversa e todo o seu histórico serão excluídos permanentemente.',
    chatDeleted: 'Conversa excluída com sucesso',
    chatArchived: 'Conversa arquivada com sucesso',
    chatRenamed: 'Conversa renomeada com sucesso',
    chatCreated: 'Nova conversa criada',
    createError: 'Erro ao criar conversa',
    renameError: 'Erro ao renomear conversa',
    archiveError: 'Erro ao arquivar conversa',
    deleteError: 'Erro ao excluir conversa',
    emptyTitleError: 'Título não pode estar vazio',
    titleTooLongError: 'Título não pode ter mais de 255 caracteres',
    showFullHistory: 'Exibir Histórico completo',
    chatActions: 'Ações da conversa',
    messageCount: {
      singular: 'mensagem',
      plural: 'mensagens'
    },
    activeChats: {
      singular: 'chat ativo',
      plural: 'chats ativos'
    },
    timeAgo: 'Agora'
  },

  // ChatMessage specific
  message: {
    shareTitle: 'Compartilhar mensagem',
    favoriteTitle: 'Favoritar mensagem',
    copyTitle: 'Copiar mensagem',
    you: 'Você',
    aiResponseTitle: 'Resposta da IA - {name}'
  },

  // PlaygroundConfigDialog specific
  config: {
    title: 'Configurações do Chat',
    loading: 'Carregando configurações...',
    saving: 'Salvando...',
    saved: 'Configurações salvas',
    savedDescription: 'As configurações do Chat foram atualizadas com sucesso.',
    reset: 'Resetar',
    cancel: 'Cancelar',
    save: 'Salvar',
    tabs: {
      rag: 'RAG & IA',
      ui: 'Interface',
      restrictions: 'Restrições'
    },
    rag: {
      title: 'Configurações de RAG e IA',
      similarityThreshold: 'Limiar de Similaridade',
      maxResults: 'Máximo de Resultados',
      temperature: 'Temperatura',
      maxTokens: 'Máximo de Tokens',
      systemPrompt: 'Prompt do Sistema',
      systemPromptPlaceholder: 'Defina o comportamento e papel da IA...'
    },
    ui: {
      title: 'Configurações de Interface',
      welcomeMessage: 'Mensagem de Boas-vindas',
      welcomeMessagePlaceholder: 'Mensagem exibida quando o usuário abre o chat...',
      inputPlaceholder: 'Placeholder do Input',
      inputPlaceholderPlaceholder: 'Texto de placeholder do campo de entrada...',
      maxChatHistory: 'Máximo de Histórico no Chat'
    },
    restrictions: {
      title: 'Restrições e Limites',
      allowedFileTypes: 'Tipos de Arquivo Permitidos',
      allowedFileTypesPlaceholder: 'pdf, txt, docx, xlsx...',
      allowedFileTypesHelp: 'Separe os tipos de arquivo por vírgula',
      maxQueryLength: 'Tamanho Máximo de Consulta (caracteres)',
      rateLimitPerMinute: 'Limite de Consultas por Minuto'
    }
  },

  // Error messages
  errors: {
    general: 'Ocorreu um erro',
    sendMessage: 'Erro ao enviar mensagem',
    loadHistory: 'Erro ao carregar histórico do chat',
    loadConfig: 'Erro ao carregar configurações',
    saveConfig: 'Erro ao salvar configurações',
    subscriptionRequired: 'Assinatura Expirada/Esgotada - Adicione mais créditos ou contrate outro plano para continuar conversando.'
  },

  // No workspace state
  no_workspace: {
    title: 'Nenhum workspace selecionado',
    description: 'Selecione um workspace para começar a usar o Chat'
  },

  // Loading states
  loading: {
    history: {
      title: "Carregando histórico...",
      description: "Recuperando suas conversas anteriores com a IA"
    }
  },

  // Legacy support
  manageChatSessions: 'Gerencie suas sessões de chat com o Brain',
  newChat: 'Nova Conversa',
  creatingChat: 'Criando...',
  noChatsYet: 'Nenhuma conversa ainda',
  createFirstChat: 'Crie sua primeira conversa ou envie uma mensagem para começar',
  renameChat: 'Renomear Conversa',
  archiveChat: 'Arquivar Conversa',
  deleteChat: 'Excluir Conversa',
  deleteConfirmTitle: 'Excluir conversa?',
  deleteConfirmDescription: 'Esta ação não pode ser desfeita. A conversa e todo o seu histórico serão excluídos permanentemente.',
  chatDeleted: 'Conversa excluída com sucesso',
  chatArchived: 'Conversa arquivada com sucesso',
  chatRenamed: 'Conversa renomeada com sucesso',
  chatCreated: 'Nova conversa criada',
  emptyStateTitle: 'Bem-vindo ao Chat!',
  emptyStateDescription: 'Selecione uma conversa existente ou envie uma mensagem para começar uma nova.',
  emptyChat: 'Chat vazio',
  startConversation: 'Envie sua primeira mensagem para começar a conversa',
  no_agent_selected: "Digite sua pergunta para começar",
  ai_thinking: "A IA está processando sua pergunta...",

  // Chat structure
  chat: {
    input_placeholder: 'Digite sua mensagem para o Brain...',
    send: 'Enviar',
    stop: 'Parar',
    stopped: 'Resposta interrompida.',
    stopFailed: 'Não foi possível parar a resposta; ela continua. Tente de novo.',
    waitingRun: 'aguardando execução… {{seconds}} s',
    queued: 'Na fila: o agente responde assim que terminar o que está fazendo.',
    traceUnavailable: 'não foi possível carregar o raciocínio desta resposta'
  },

  // Tarefas que o agente acompanha depois da resposta (AB#86889)
  backgroundTasks: {
    badge_one: '{{count}} tarefa em andamento',
    badge_other: '{{count}} tarefas em andamento',
    title: 'Tarefas em segundo plano',
    noRequest: 'Tarefa sem descrição',
    cancel: 'Cancelar tarefa',
    cancelFailed: 'Não foi possível cancelar. Tente de novo.',
    listMarker: 'Em andamento',
    replyElsewhere: 'Uma tarefa terminou em "{{title}}"',
    replyElsewhereUntitled: 'Uma tarefa terminou em outra conversa',
    open: 'Abrir conversa',
    status: {
      watching: 'Em andamento',
      completing: 'Concluindo',
      delivered: 'Concluída',
      failed_delivery: 'Falhou ao responder',
      cancelled: 'Cancelada',
      expired: 'Expirada'
    }
  },

  attachments: {
    add: 'Anexar arquivos',
    remove: 'Remover {{name}}',
    tooLarge: 'Arquivos acima de 50 MB não foram anexados',
    uploadFailed: 'Não foi possível anexar os arquivos',
    truncated: 'parcial',
    truncatedHint: 'O arquivo é longo: o assistente leu só o começo dele.',
    summarizing: 'resumindo',
    summarizingHint: 'O arquivo é longo: o assistente lê o começo e qualquer parte de que precisar, e um resumo do arquivo inteiro está sendo preparado.',
    summarized: 'resumido',
    summarizedHint: 'O arquivo é longo: o assistente tem um resumo do arquivo inteiro e lê qualquer parte de que precisar.',
    summaryFailed: 'sem resumo',
    summaryFailedHint: 'Não foi possível preparar o resumo do arquivo inteiro. O assistente continua lendo o começo e qualquer parte de que precisar.',
    unreadable: 'sem texto',
    unreadableHint: 'Não foi possível ler texto deste arquivo (por exemplo, um PDF escaneado).',
    open: 'Abrir {{name}}',
    openFailed: 'Não foi possível abrir o arquivo',
    openFailedHint: 'Os anexos ficam disponíveis por 24 horas. Se você o guardou na Knowledge, abra pelo Brain → Files.'
  },

  // MCP Tools discovery
  mcpTools: {
    title: 'Ferramentas MCP',
    openDialog: 'Ver todas as ferramentas MCP e configuração',
    tabs: {
      integrations: 'Apps',
      core: 'Core',
      config: 'Conectar'
    },
    integrations: {
      empty: 'Nenhuma ferramenta com operações MCP instalada para este workspace.',
      catalogNotePrefix: 'Em conexões externas, estas operações são executadas pela ferramenta ',
      catalogNoteMiddle: ', que traz o índice de todas elas. Para expor cada operação como uma ferramenta própria, acrescente ',
      catalogNoteSuffix: ' à URL do MCP.',
      toolCount_one: '{{count}} ferramenta',
      toolCount_other: '{{count}} ferramentas'
    },
    coreGroups: {
      session: 'Sessão',
      profile: 'Perfil',
      brain: 'Brain',
      memory: 'Memória',
      utilities: 'Utilitários',
      integrations: 'Ferramentas',
      skills: 'Skills',
      jobs: 'Jobs',
      flows: 'Flows',
      admin: 'Admin (SUPERADMIN / ADMIN)'
    },
    coreTools: {
      session_load: 'O início de toda conversa: usuário, organização, preferências de IA e a identidade do workspace — a Soul, o índice da Mind e os membros.',
      brain_load: 'O Brain do workspace: a Mind e um indicador da Knowledge — e a Soul e os membros de outro workspace.',
      mind_get: 'Um bloco da Mind inteiro, pela chave: para os blocos que o Brain traz cortados ou só no índice.',
      facets_load: 'O vocabulário de facets da organização, para marcar blocos da Mind e filtrar a busca na Knowledge.',
      mind_submit: 'Cria, altera ou exclui um bloco destrancado da Mind (ADMIN). A Soul nunca muda por aqui.',
      memory_search: "Busca o que pessoas e agentes pediram para lembrar (pessoal, workspace e organização), como fatos com validade.",
      memory_list: "Lista as memórias de um escopo, das mais recentes, com autor, origem e validade.",
      memory_submit: "Grava, altera ou esquece uma memória. Só o que a pessoa pediu para lembrar; as da organização só ADMIN.",
      profile_submit: 'Altera o perfil do usuário: idioma, instruções pessoais de IA e a confirmação antes de ações destrutivas.',
      knowledge_search: 'Busca semântica (RAG) sobre o knowledge base.',
      knowledge_get: 'Lista os documentos da Knowledge, lê um inteiro ou gera um link temporário de download.',
      knowledge_submit: 'Envia, substitui, troca as facets ou exclui documentos da Knowledge — por link, envio direto ou conteúdo. Excluir pede confirmação.',
      tools_load: 'Ferramentas disponíveis no workspace: nome da instalação, escopo e operações.',
      tools_get: 'Lê o schema e as regras de operações de uma instalação, sem executar.',
      tools_run: 'Executa uma operação de uma instalação. A descrição traz o índice de todas as operações.',
      tools_store: 'Catálogo de ferramentas do Prodgy: listar, ver um template e instalar.',
      tools_submit: 'Cria, atualiza ou remove um template de ferramenta (SUPERADMIN / ADMIN).',
      skills_load: 'Skills instaladas para você: nome e descrição. Carregada quando o pedido precisa.',
      web_search: 'Busca na internet com fontes: provedor gratuito primeiro e, se falhar, os provedores pagos configurados pela plataforma.',
      skills_get: 'Instruções completas de uma Skill, com o inventário dos arquivos de apoio.',
      skills_resource: 'Lê um arquivo de apoio de uma Skill.',
      skills_run: 'Roda um script Python que vem com uma Skill, num ambiente isolado. Só no agente do Prodgy — agentes externos não a recebem.',
      skills_store: 'Catálogo de Skills: listar, ver, instalar e desinstalar (instalar e desinstalar exigem ADMIN).',
      skills_submit: 'Submete um pacote de Skill: para o seu espaço ou para o catálogo da organização.',
      jobs_load: 'Jobs do workspace: a instrução, o gatilho, publicado ou não e a última execução.',
      jobs_get: 'Um job (instrução, gatilho, webhook) ou uma execução, com o relatório do agente.',
      jobs_runs: 'Histórico de execuções de todos os jobs, com filtro por status, período e job.',
      jobs_submit: 'Cria, altera, testa, publica ou exclui um job a partir de uma instrução, que cita a Skill, e de um gatilho (ADMIN da organização).',
      flows_load: 'Fluxos do workspace: publicado ou não, gatilhos ativos e última execução.',
      flows_get: 'Um fluxo (rascunho, versão publicada, gatilhos) ou uma execução, passo a passo.',
      flows_steps: 'Passos disponíveis para montar um fluxo, ou como configurar um deles.',
      flows_submit: 'Cria, altera, testa ou publica um fluxo (ADMIN da organização).',
      get_mcp_settings: 'Lê as instruções e regras de export atuais do servidor MCP.',
      update_mcp_settings: 'Atualiza as instruções e regras de export do servidor MCP.'
    },
    config: {
      oneClickTitle: 'Conectar em um clique',
      oneClickDescription: 'O editor abre o login do Prodgy na primeira chamada; ali você autoriza e escolhe o workspace. Não precisa de token.',
      addToCursor: 'Adicionar ao Cursor',
      addToVsCode: 'Adicionar ao VS Code',
      claudeCodeTitle: 'Claude Code',
      urlTitle: 'Outros agentes (Claude, ChatGPT e afins)',
      urlDescription: 'Adicione um conector MCP personalizado com esta URL. O login do Prodgy abre na primeira vez.',
      manualTitle: 'Configuração manual com token',
      descriptionPrefix: 'Adicione este snippet à configuração do seu cliente MCP (',
      descriptionSuffix: ').',
      tokenHintPrefix: 'Gere um token em ',
      tokenHintBold: 'Configurações do Workspace → API Tokens',
      tokenHintSuffix: '.',
      copy: 'Copiar',
      copied: 'Copiado',
      copyFailed: 'Falha ao copiar para a área de transferência'
    }
  },

  // Embed Widget
  embedWidget: {
    title: 'Embedar Widget',
    subtitle: 'Incorporar chat widget para',
    embedButton: 'Embedar Widget',
    customize: 'Personalizar',
    widgetTitle: 'Título do Widget',
    width: 'Largura (px)',
    height: 'Altura (px)',
    theme: 'Tema',
    themeLight: 'Claro',
    themeDark: 'Escuro',
    embedCode: 'Código de Incorporação',
    iframeDescription: 'Cole este código na sua página HTML para incorporar o widget de chat.',
    scriptDescription: 'Adicione este script à sua página para um widget de chat flutuante automático.',
    directUrl: 'URL Direto',
    codeCopied: 'Código copiado',
    codeCopiedDescription: 'O código de incorporação foi copiado para a área de transferência.',
    copyFailed: 'Falha ao copiar'
  }
} as const;

export default playground;
